import { render, staticRenderFns } from "./NotaryVerify.vue?vue&type=template&id=a6a215a2&scoped=true&"
import script from "./NotaryVerify.vue?vue&type=script&lang=js&"
export * from "./NotaryVerify.vue?vue&type=script&lang=js&"
import style0 from "./NotaryVerify.vue?vue&type=style&index=0&id=a6a215a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a215a2",
  null
  
)

export default component.exports